define('modules/form_editor/views/preview_dropdown_item',['require','exports','module','base/itemview','../../editor/models/editorstate','ldsh!../templates/dropdown_item'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview"),
      EditorState = require("../../editor/models/editorstate");
  module.exports = ItemView.extend({
    template: require("ldsh!../templates/dropdown_item"),
    tagName: "option",
    initialize: function(options){
      this.inputName = options.parent.model.get("nameAttr");
      this.isRequired = options.parent.model.get("isRequired");
    },
    helpers: function(){
      return {
        inputName: this.inputName,
        isAMP: EditorState.getAMPState()
      };
    },
    onRender: function(){
      //we do this onrender because the 'attributes' function
      //is not called again upon model change
      var optionValue = this.model.get("value") || this.model.get("text");
      this.$el.attr("value", this.model.get("valid") ? optionValue : "");
    }
  });
});

